import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar({ onLogout, isAdmin = false }) {
  return (
    <header className="app-navbar">
      <div className="app-navbar-inner">
        <Link aria-label="Yants home" className="app-navbar-brand" to="/">
          <span className="app-navbar-mark">Y</span>
          <span className="app-navbar-brand-copy">
            <strong>Yants</strong>
            <small>Community workspace</small>
          </span>
        </Link>
        <nav aria-label="Workspace" className="app-navbar-links">
          <NavLink className={({ isActive }) => `app-navbar-link${isActive ? " is-active" : ""}`} end to="/">Home</NavLink>
          <NavLink className={({ isActive }) => `app-navbar-link${isActive ? " is-active" : ""}`} to="/profile">Profile</NavLink>
          {isAdmin && <NavLink className={({ isActive }) => `app-navbar-link${isActive ? " is-active" : ""}`} to="/admin/users">Users</NavLink>}
          {isAdmin && <NavLink className={({ isActive }) => `app-navbar-link${isActive ? " is-active" : ""}`} to="/admin/channels">Channels</NavLink>}
        </nav>
        <button className="app-navbar-logout" onClick={onLogout} type="button">Log out</button>
      </div>
    </header>
  );
}
